import { BusEvent } from '@web/common';

export class WarehouseReceiptChangedBusEvent extends BusEvent {}
